export default __webpack_public_path__ + "static/media/about-thumb-10-challenge.784f0955.png";